<!--
 * @Author: luohongbiao
 * @Date: 2022-01-05 10:07:24
 * @LastEditTime: 2022-07-23 09:59:03
 * @LastEditors: LHB
 * @Description: 
 * @FilePath: \shirleyClass\src\modules\Home\index.vue
-->
<template>
  <div class="wrap">
    <!-- 学习页面-start -->
    <div v-show="active == 0" class="item-box learn-box">
      <div class="header">
        <van-swipe v-if="active == 0" :autoplay="3000">
          <van-swipe-item
            v-for="(item, index) in bannerList"
            :key="index"
            @click="swiperClick(index)"
          >
            <img class="sw-img" v-lazy="item.pic" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="content">
        <div class="box-title">我的课程</div>
        <div class="box-class">
          <!-- 课程列表-start -->
          <template v-if="classList && classList.length != 0">
            <div
              class="class-item"
              v-for="(item, index) in classList"
              :key="index"
            >
              <div class="class-left">
                <img class="class-log" :src="item.pic" alt="" />
              </div>
              <div class="class-right">
                <div class="class-right-top">
                  <div class="class-title">{{ item.title }}</div>
                  <div v-if="item.learnLast" class="class-time">
                    上次学：{{ item.learnLast }}
                  </div>
                </div>
                <div class="class-right-bottom">
                  <div class="class-btn" @click="golearn(index)">去上课</div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="class-empty">
              <img
                class="class-empty-logo"
                src="../../assets/images/empty_img_invite.png"
                alt=""
              />
              <span class="class-empty-title">暂无课程</span>
            </div>
          </template>
          <!-- 课程列表-end -->
        </div>
      </div>
    </div>
    <!-- 学习页面-end -->
    <!-- 我的-start -->
    <div v-show="active == 1" class="my-box">
      <div class="info-box">
        <div class="info-top">
          <div class="info-topleft">
            <img
              class="avtor"
              :src="user.avatar ? user.avatar : avatar_message_photo"
              alt=""
            />
            <div class="user-box">
              <div class="user-name">{{ user.nickname }}</div>
              <div class="user-phone">手机号:{{ user.mobile }}</div>
            </div>
          </div>
          <div class="outbtn" @click="logout">退出</div>
        </div>
        <div class="info-bottom">
          <div class="info-item info-item-line">
            <div class="info-item-title">{{ user.name }}</div>
            <div class="info-item-des">学员姓名</div>
          </div>
          <div class="info-item info-item-line">
            <div class="info-item-title">
              {{ user.gender == 1 ? '男' : '女' }}
            </div>
            <div class="info-item-des">学员性别</div>
          </div>
          <div class="info-item">
            <div class="info-item-title">{{ user.birth }}</div>
            <div class="info-item-des">学员生日</div>
          </div>
        </div>
      </div>
      <div class="menu-box">
        <div
          class="menu-item"
          v-for="(item, index) in menuList"
          :key="index"
          @click="menujump(index)"
        >
          <div class="menu-left">
            <img class="menu-icon" :src="item.icon" alt="" />
            <div class="menu-title">{{ item.title }}</div>
          </div>
          <img
            class="arrow"
            src="../../assets/images/list_icon_arrow_r@2x.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 我的-end -->

    <!-- tabbar-start -->
    <van-tabbar
      v-model="active"
      safe-area-inset-bottom
      active-color="#323233"
      inactive-color="#969799"
      @change="tabBarChange"
    >
      <van-tabbar-item>
        <span class="tabbar-title">去学习</span>
        <template #icon="props">
          <img :src="props.active ? learnIcon.active : learnIcon.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span class="tabbar-title">我的</span>
        <template #icon="props">
          <img :src="props.active ? myIcon.active : myIcon.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
    <!-- tabbar-end -->

    <!-- 组件 -->
    <confirmModal
      v-if="isShowLogout"
      :isShowpop="isShowLogout"
      @cancle="logoutCancle"
      @confirm="logoutConfirm"
    ></confirmModal>
  </div>
</template>
<script>
import group from '../common/group'
import utils from '../../utils/index.js'
import tools from '../common/tools.js'
import wx_tools from '../common/wx_tools.js'

import study_icon_light from '../../assets/images/study_icon_light@2x.png'
import study_icon_dark from '../../assets/images/study_icon_gray@2x.png'
import my_icon_light from '../../assets/images/my_icon_light@2x.png'
import my_icon_dark from '../../assets/images/my_icon_gray@2x.png'
// 我的-菜单按钮icon
import my_order_icon from '../../assets/images/my_order_icon@2x.png'
import my_phone_icon from '../../assets/images/my_phone_icon@2x.png'
import my_wechat_icon from '../../assets/images/my_wechat_icon@2x.png'
import my_letter_icon from '../../assets/images/my_letter_icon@2x.png'
import my_revise_icon from '../../assets/images/my_revise_icon@2x.png'
import my_lock_icon from '../../assets/images/my_lock_icon@2x.png'
import avatar_message_photo from '../../assets/images/avatar_message_photo.png'
import confirmModal from '../../components/ConfirmModal'
export default {
  name: 'home',
  components: { confirmModal },
  data() {
    return {
      active: 0,
      token: '',
      user: '',
      activeKey: 'activeKey',
      tokenKey: 'tokenKey',
      wxThirdid: '',
      wxThirdidKey: 'wxThirdidKey',
      avatar_message_photo: avatar_message_photo,
      learnIcon: {
        active: study_icon_light,
        inactive: study_icon_dark
      },
      myIcon: {
        active: my_icon_light,
        inactive: my_icon_dark
      },
      isShowLogout: false,
      bannerList: [],
      classList: [],
      menuList: [
        {
          icon: my_order_icon,
          title: '我的订单',
          pathName: 'orderList'
        },
        {
          icon: my_order_icon,
          title: '兑换课程',
          pathName: 'redeem'
        },
        // {
        //   icon: my_phone_icon,
        //   title: '更换课程手机号',
        //   pathName: 'changemobile'
        // },
        {
          icon: my_wechat_icon,
          title: '更换上课微信',
          pathName: 'changeWx'
        },
        {
          icon: my_letter_icon,
          title: '雪梨老师信箱',
          pathName: 'email'
        },
        {
          icon: my_revise_icon,
          title: '编辑资料',
          pathName: 'edit'
        },
        {
          icon: my_lock_icon,
          title: '修改密码',
          pathName: 'reset'
        }
      ],
      testclass: false
    }
  },
  mounted() {
    document.title = '雪梨英语'
    this.active = Number(localStorage.getItem(this.activeKey)) || 0
    this.token = localStorage.getItem(this.tokenKey)
    this.wxThirdid = localStorage.getItem(this.wxThirdidKey)

    // this.user = JSON.parse(localStorage.getItem(this.userKey))

    console.log('home', this.token, this.user)
    // banner
    this.getBannerList()
    // list
    this.courseList()
    // 获取用户信息
    this.getUser()

    this.initShare()
  },
  methods: {
    tabBarChange(active) {
      console.log(active)
      this.active = active
      localStorage.setItem(this.activeKey, active)
    },
    getUser() {
      const params = { token: this.token }
      group.userGet
        .call(this, params)
        .then((res) => {
          console.log('用户信息', res)
          if (res.data.success) {
            this.user = res.data.data
            // 后台手动解绑了微信，需要踢出
            if (!this.user.thirdId || !this.user.mobile) {
              localStorage.clear()
              this.$router.replace({
                name: 'login'
              })
            }
          } else {
            this.$toast(res.data.error.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getBannerList() {
      if (this.active == 0) {
        utils.tools.showLoading()
      }
      const params = { token: this.token }
      group.bannerList
        .call(this, params)
        .then((res) => {
          console.log('banner', res)
          utils.tools.hideLoading()
          if (res.data.success) {
            this.bannerList = res.data.data
          } else {
            this.$toast(res.data.error.msg)
          }
        })
        .catch((error) => {
          utils.tools.hideLoading()
          console.log(error)
        })
    },
    courseList() {
      const params = { token: this.token }
      group.courseList
        .call(this, params)
        .then((res) => {
          console.log('classList', res)
          if (res.data.success) {
            this.classList = res.data.data
          } else {
            this.$toast(res.data.error.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    swiperClick(index) {
      const url = this.bannerList[index].link
      if (!url) {
        // this.$toast('暂无跳转链接')
        return
      } else {
        window.location.href = url
      }
    },
    golearn(index) {
      const url = this.classList[index].goUrl
      const id = this.classList[index].id
      console.log('url', url)
      console.log('url', id)
      if (!url) {
        // this.$toast('暂无学习链接')
        console.log('无上课链接')
        return
      } else {
        console.log('去上课---', this.user.thirdId, this.wxThirdid)
        if (this.user.thirdId != this.wxThirdid) {
          this.$router.push({
            name: 'bindwxerror'
          })
          return
        }

        // 上报
        const params = { token: this.token, id: id }
        group.reportLearn
          .call(this, params)
          .then((res) => {
            console.log('上报', res)
            window.location.href = url
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    menujump(index) {
      const item = this.menuList[index]
      this.$router.push({
        name: item.pathName,
        query: {}
      })
    },
    logout() {
      this.isShowLogout = true
    },
    logoutCancle() {
      console.log('logoutCancle')
      this.isShowLogout = false
    },
    logoutConfirm() {
      // 清缓存
      localStorage.clear()
      localStorage.setItem('logout', 1)
      this.isShowLogout = false
      this.$router.replace({
        name: 'login'
      })
    },
    initShare() {
      console.log('调用initShare')
      const tempJumpLink = utils.config.config.shareUrl
      // 分享字数规则：主标题两行，副标题3行，超出全部...
      let shareObj = {
        debug: false,
        referer: tempJumpLink,
        appId: utils.config.config.appId,
        title: utils.config.config.shareMainTitle,
        desc: utils.config.config.shareDesTitle,
        link: tempJumpLink,
        imgUrl: utils.config.config.shareImgUrl,
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '' // 如果type是music或video，则要提供数据链接，默认为空
        // success: this.shareSuccess
        // fail: this.shareFail
      }
      console.log('分享跳转地址--login', shareObj)
      wx_tools.initShare.call(this, shareObj)
    }
  }
}
</script>

<style src="./index.css" scoped></style>
<style>
.van-tabbar-item__icon img {
  display: block;
  width: 26px;
  height: 26px;
}
</style>
